<template>
  <div class="conmain">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-button type="primary" round @click="video_up('add','')">新增视频</el-button>
    <el-table stripe :data="video_list.data" style="width: 100%">
      <el-table-column label="编号" prop="num">
      </el-table-column>
      <el-table-column label="封面">
        <template slot-scope="scope">
          <img :src="scope.row.img" style="height: 2rem;" />
        </template>
      </el-table-column>
      <el-table-column label="视频名" prop="name">
      </el-table-column>
      <el-table-column label="讲师" prop="teacher">
      </el-table-column>
      <el-table-column label="分类" prop="type">
      </el-table-column>
      <el-table-column label="转码" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.m3u8=='0'" style="cursor:pointer;" @click="m3u8()">转码</p>
           <p v-if="scope.row.m3u8=='1'">转码中</p>
           <p v-if="scope.row.m3u8=='2'"style="cursor:pointer;" @click="m3u8()">重新转码</p>
         </template>
      </el-table-column>
      <el-table-column label="音频" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.audio=='0'" style="cursor:pointer;" @click="audio(scope)">提取</p>
           <p v-else-if="scope.row.audio=='1'">提取中</p>
           <p v-else style="cursor:pointer;" @click="audio(scope)">
             重新提取
           </p>
         </template>
      </el-table-column>
      <el-table-column label="状态" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.status=='1'">启用中</p>
           <p v-else>已禁用</p>
         </template>
      </el-table-column>
      <el-table-column align="right" width="220">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" @keyup.enter.native="search_click()" size="mini" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button size="mini" type="success" plain @click.native="video_watch(scope.row.num)">观看</el-button>
          <el-button size="mini" type="primary" plain @click="video_up('edit', scope.row.num)">编辑</el-button>
          <el-button size="mini" type="success" v-if="scope.row.status!='1'" plain @click="video_del(scope.row.num)">启用</el-button>
          <el-button size="mini" type="danger" v-else plain @click="video_del(scope.row.num)">禁用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="video_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="video_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="video_list.total">
      </el-pagination>
    </div>

    <el-dialog :title="nav_status.video_dialog_title" :visible.sync="nav_status.video_dialog">
     <p>课程名:&nbsp;&nbsp;&nbsp;&nbsp;<el-input v-model="video_edit.name" placeholder="请输入内容" style="width: 50%;"></el-input></p>
     <p>资源分类:
          <div v-html="type_choiced.html" @click="del_type_edit_fid_click($event)"></div>
          <el-button plain @click="type_choice()">请选择</el-button>
     </p>
     <p>讲师:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <el-select v-model="video_edit.teacher" filterable placeholder="请选择">
       <el-option
        v-for="item in teacher_list"
        :key="item.num"
        :label="item.name"
        :value="item.num">
       </el-option>
      </el-select>
     </p>
     <p style="width: 100%; ">封面
           <el-upload class=" eidtbtn"
                     ref="cropper"
                     action=""
                     accept="image/*"
                     drag
                     :auto-upload="false"
                     :show-file-list="false"
                     :on-change='change_img'>
                     请选择图片
                     <div  style="width: 100%; height: 80%; display: flex; justify-content: center;">
                       <img :src="video_edit.img" style=" height: 100%;" />
                     </div>
                   </el-upload>
                   </p>
     <p>视频
      <el-upload
        class="upload-demo"
        accept=".MP4"
        ref="upload"
        action=""
        :http-request="video_save"
        :on-exceed="video_check"
        :file-list="fileList"
        :on-change="video_change"
        :before-remove="video_remove"
        :limit="1"
        :auto-upload="false">
        <el-button style="margin-left: 10px;" size="small" type="success" @click="video_submit('watch')">预览</el-button>
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        </el-upload>
     </p>

     <p>简介 <div class="eidtbtn">
      <el-input  style="width: 71%;" :rows="6" type="textarea"  placeholder="请输入简介" v-model="video_edit.content"> </el-input></div>
     </p>
     <p>详情
     <div class="eidtbtn">
      <el-input  style="width: 71%;" :rows="6" type="textarea"  placeholder="请输入详情" v-model="video_edit.info"> </el-input></div></p>
      <el-progress :percentage="progress"/>
      <div slot="footer" class="dialog-footer">
      <el-button @click="nav_status.video_dialog=false">取 消</el-button>
      <el-button type="primary" @click="video_submit('upload')">确 定</el-button>
    </div>
    </el-dialog>

    <el-dialog title="视频预览":visible.sync="nav_status.video_watch_dialog">
      <video :src="nav_status.video_url" class="avatar" controls="controls" style="width: 100%;"></video>
       <div slot="footer" class="dialog-footer">
         <el-button @click="nav_status.video_watch_dialog=false">关闭</el-button>
       </div>
    </el-dialog>


    <!-- <el-dialog title="所属分类":visible.sync="nav_status.type_choice_dialog" :before-close="handleClose">
      <div style="display: flex;">
        <div class="ercitankuang_left">
          <el-tree @node-click="type_fid"
             :data="type_list"
              ref="tree"
              node-key="num"
             :default-expanded-keys="tree_default"
             :props="defaultProps">
         </el-tree>
        </div>
        <div class="ercitankuang_content">
          <i class="el-icon-right"></i>
        </div>
          <div class="ercitankuang_right">
           <div v-html="type_choiced.html" @click="del_type_edit_fid_click($event)"></div>
          </div>
      </div>

       <div slot="footer" class="dialog-footer">
         <el-button @click="type_choice_remove()">取 消</el-button>
         <el-button type="primary" @click="nav_status.type_choice_dialog = false">确 定</el-button>
       </div>
    </el-dialog> -->

    <el-dialog title="所属分类":visible.sync="nav_status.type_choice_dialog" :before-close="handleClose" width="80%">
      <div >
        <h4>您选择的是:
        <span v-html="type_choiced.html" @click="del_type_edit_fid_click($event)"></span>
        </h4>
        <div>
          <el-input
          style="margin: 0.625rem;"
          placeholder="输入关键字进行过滤"
            v-model="filterText">
          </el-input>
          <el-row class="over" :style="{height:dialog_Height}">
            <el-tree
             :filter-node-method="filterNode"
               @node-click="type_fid"
                :data="type_list"
                 ref="tree"
                 node-key="num"
                :default-expanded-keys="tree_default"
                :props="defaultProps">
                <span class="custom-tree-node" slot-scope="{data}">
                  <div class="dia_tree_data" :style="{width:dialog_width}" >{{ data.name }}</div>
                </span>
            </el-tree>
          </el-row>

        </div>
      </div>

       <div slot="footer" class="dialog-footer">
         <el-button @click="type_choice_remove()">取 消</el-button>
         <el-button type="primary" @click="nav_status.type_choice_dialog = false">确 定</el-button>
       </div>
    </el-dialog>


  </div>

</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    watch: {
         filterText(val) {
           this.$refs.tree.filter(val);
         }
       },
    data() {
      return {
        dialog_Height:window.innerHeight * 0.5 + 'px',
        dialog_width:window.innerWidth -500 + 'px',
        filterText: '',
        liad_show:true,
        tree_default:[],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        fileList: [],
        nav_status:{
          type_choice_dialog:false,
          video_dialog:false,
          video_watch_dialog:false,
          video_url:'',
          type:'',
          submit_type:''
        },
        video_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        type_list:{},
        teacher_list:{},
        video_edit:{
          name:'',
          img:''
        },
        type_choiced:{
          html:''
        },
        search: '',
        progress:0
      }
    },
    components: {
      load:load
    },

    mounted() {
      this.get_video()
    },

    methods: {
      filterNode(value, data) {
         if (!value) return true;
         return data.name.indexOf(value) !== -1;
       },
      audio(scope){
        let _this=this
        _this.axios.post('/v2/c_resource/get_video_audio',{num:scope.row.num}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success('提交成功')
              _this.video_list.data[scope.$index].audio='1'
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      search_click(){
        this.get_video()
      },
      m3u8(){
        this.$message.error("请联系平台进行相关操作")
      },
      get_video(){
        let _this=this
        _this.axios.get('/v2/c_resource/get_video',{params:{'page':_this.video_list.current_page,'limit':_this.video_list.per_page,'type':'1','status':'1','keyword':_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.video_list=res.data.data
              _this.video_list.per_page=parseInt(_this.video_list.per_page)
              _this.get_type()
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_type(){
        let _this=this
        _this.axios.get('/v2/c_resource/get_video_type').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.type_list=res.data.data
              _this.get_teacher()
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_teacher(){
        let _this=this;
        _this.axios.get('/v2/c_resource/get_teacher',{params:{'page':'1','limit':'9999','type':'1','status':'1'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.teacher_list=res.data.data.data
              _this.liad_show=false
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      get_video_info(num){
        let _this=this;
        _this.axios.get('/v2/c_resource/get_video_info',{params:{'num':num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.video_edit=res.data.data
              _this.change_type_choiced()
              _this.show_video_dialog()
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      handleSizeChange(val) {
        this.video_list.current_page = 1;
        this.video_list.per_page = val
        this.get_video()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.video_list.current_page = val
        _this.get_video()
      },

      show_video_dialog(){
        let _this=this
        _this.nav_status.video_dialog=true
        _this.$refs.upload.clearFiles()
      },

      video_up(type,num){
        let _this=this
        _this.video_edit={name:'',img:''}
        _this.nav_status.submit_type=type
        _this.progress=0
        if(type=='add'){
          _this.show_video_dialog()
        }else{
          _this.get_video_info(num)
        }
      },

      change_img(event){
        let _this=this
        _this.get_img_base64(event.raw).then(res => {
             _this.video_edit.img=res
         });
      },

      get_img_base64(file) {
          return new Promise(function(resolve, reject) {
              let reader = new FileReader();
              let imgResult = "";
              reader.readAsDataURL(file);
              reader.onload = function() {
                  imgResult = reader.result;
              };
              reader.onerror = function(error) {
                  reject(error);
              };
              reader.onloadend = function() {
                  resolve(imgResult);
              };
          });
      },

      type_choice(){
        this.nav_status.type_choice_dialog=true
      },

      type_fid(data){
        let _this=this
        _this.type_choiced.html=''
        _this.video_edit.resource_type={}
        _this.save_type_edit_fid(data)
      },

      change_type_choiced(){
        let _this=this
        _this.type_choiced.html=''
        for(let key  in _this.video_edit.resource_type){
          _this.type_choiced.html+="<span>"+_this.video_edit.resource_type[key]+"<span class='"+key+"' style='padding:0 20px;cursor:pointer'>X</span></span>"
        }
      },

      del_type_edit_fid_click:function(event){
        let _this=this
        if(event.target.className){
          _this.del_type_edit_fid(event.target.className)
        }else{
          return false;
        }
      },

      save_type_edit_fid(data){
        let _this=this
        _this.video_edit.resource_type[data.num]=data.name
        _this.change_type_choiced()
      },

      del_type_edit_fid(num){
        let _this=this
        delete _this.video_edit.resource_type[num];
        _this.change_type_choiced()
      },

      type_choice_remove(done){
        let _this=this
        _this.$confirm('确认取消所选分类？').then(_ => {
          _this.type_choiced.html=''
          _this.video_edit.resource_type={}
          done();
        })
        .catch(_ => {});
      },

      handleClose(done) {
        let _this=this
        _this.$confirm('确认所选分类？').then(_ => {
          done();
        })
        .catch(_ => {});
      },

      video_submit(type){
        let _this=this
        _this.nav_status.type=type
        // console.log(type)
        if(type=='add'){
            if(_this.fileList==0){
              // console.log('0')
              // return
              _this.$message.error('请选择视频文件')
            }else{
              // console.log('1')
              // return
              _this.$refs.upload.submit()
            }
        }else{
          // console.log('2')
          // return
          if(_this.fileList==0){
            _this.save()
          }else{
            _this.$refs.upload.submit()
          }
        }

      },

      video_save(file){
        let _this=this
        var files =file.file
        if(_this.nav_status.type=='watch'){
          _this.nav_status.video_url = URL.createObjectURL(files);
          _this.nav_status.video_watch_dialog=true
        }else{
          var data = new FormData();
          data.append('type',_this.nav_status.submit_type)
          if(_this.nav_status.submit_type!='add'){
            data.append("num", _this.video_edit.num)
          }
          data.append("name", _this.video_edit.name)
          data.append("teacher", _this.video_edit.teacher)
          data.append("content", _this.video_edit.content)
          data.append("info", _this.video_edit.info)
          data.append("video", files)
          if(_this.video_edit.img!=''){
            data.append("img", _this.video_edit.img)
          }
          if(_this.video_edit.hasOwnProperty('resource_type')){
            var temp=Array()
            for(var key in _this.video_edit.resource_type){
              temp.push(key)
            }
            data.append("resource_type", temp[0])
          }
          _this.axios.post('/v2/c_resource/video_up',data,{
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
                let num = progressEvent.loaded / progressEvent.total * 100 | 0;  //百分比
                _this.progress=num
            } ,
          }).then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                _this.$message.success(res.data.msg)
                _this.nav_status.video_dialog=false
                _this.get_video()
              }else{
                const h = _this.$createElement
                _this.$notify({
                  title: '上传提示',
                  message: h('b', { style: 'color: red'}, res.data.msg),
                  duration: 0
                })
              }
            }else{
              const h = _this.$createElement
              _this.$notify({
                title: '上传提示',
                message: h('b', { style: 'color: red'}, '服务器内部错误'),
                duration: 0
              })
            }
          }).catch(function(error) {
            const h = _this.$createElement
            _this.$notify({
              title: '上传提示',
              message: h('b', { style: 'color: red'}, '服务器内部错误'),
              duration: 0
            })
          });
        }
      },

      save(){
        let _this=this
        var data = new FormData();
        data.append("num", _this.video_edit.num)
        data.append('type',_this.nav_status.submit_type)
        data.append("name", _this.video_edit.name)
        data.append("teacher", _this.video_edit.teacher)
        data.append("content", _this.video_edit.content)
        data.append("info", _this.video_edit.info)
        if(_this.video_edit.img!=''){
          data.append("img", _this.video_edit.img)
        }
        if(_this.video_edit.hasOwnProperty('resource_type')){
          var temp=Array()
          for(var key in _this.video_edit.resource_type){
            temp.push(key)
          }
          data.append("resource_type", temp[0])
        }
        _this.axios.post('/v2/c_resource/video_up',data,{
          headers: { "Content-Type": "multipart/form-data" } ,
          onUploadProgress: (progressEvent) => {
              let num = progressEvent.loaded / progressEvent.total * 100 | 0;  //百分比
              _this.progress=num
          } ,
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.nav_status.video_dialog=false
              _this.get_video()
            }else{
              const h = _this.$createElement
              _this.$notify({
                title: '上传提示',
                message: h('b', { style: 'color: red'}, res.data.msg),
                duration: 0
              })
            }
          }else{
            const h = _this.$createElement
            _this.$notify({
              title: '上传提示',
              message: h('b', { style: 'color: red'}, '服务器内部错误'),
              duration: 0
            })
          }
        }).catch(function(error) {
          const h = _this.$createElement
          _this.$notify({
            title: '上传提示',
            message: h('b', { style: 'color: red'}, '服务器内部错误'),
            duration: 0
          })
        });
      },

      video_del(video){
        let _this=this
        _this.axios.post('/v2/c_resource/video_up',{'type':'del','num':video}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_video()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      video_check(){
        let _this=this
        _this.$message.error('请先删除列表中的视频文件')
      },

      video_change(file, fileList){
        let _this=this
        _this.fileList=fileList
      },

      video_remove(){
        this.fileList=[]
      },

      video_watch(num){
        let routeData = this.$router.resolve({
          query: {num:num,type:1,resource:'v'},
          path:'/courseplay'
        });
        window.open(routeData.href, '_blank');
      },

    },


    }
</script>

<style scoped>
  >>>.el-tree>.el-tree-node {
    width: calc(100% - 45px);
    border: 2px solid #f6f8ff;
    /* box-shadow: 5px 5px 3px #f6f8ff; */
    padding: 5px;
    margin: 0.625rem;
  }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
   .tree_data{
     overflow: hidden;
     text-overflow: ellipsis;
   }
   .dia_tree_data{
     overflow-x: hidden;
     text-overflow: ellipsis;
   }
   .over{
     overflow: auto;
     overflow-x:hidden;
   }
  .eidtbtn {
    padding: 0 40px;
    line-height: 40px;
  }
  .conmain {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
  .ercitankuang_left{
   border:1px solid 	#9D9D9D;
   height: 200px;
   flex: 1;
   overflow:scroll;
  }
  .ercitankuang_right{
    border:1px solid 	#9D9D9D;
    height: 200px;
    flex: 1;
    overflow:scroll;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/course/SelfCourse/Video.vue